// extracted by mini-css-extract-plugin
export var productImage = "_m6-1";
export var viewLink = "_m6-2";
export var wishlistItem = "_m6-0";